import { z } from 'zod';

export const AchPaymentStatusFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('status'),
  filter: z.object({
    values: z.array(z.enum(['PENDING', 'BATCHED', 'PROCESSED', 'FAILED', 'CANCELLED'])),
  }),
});

export const AchTransactionTypeFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('transactionType'),
  filter: z.object({
    values: z.array(z.enum(['payment', 'prenote'])),
  }),
});

export const AchBatchDateFilter = z.object({
  type: z.literal('dateRange'),
  key: z.literal('batchDate'),
  filter: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
  }),
});

export const AchBatchTransactionFilter = z.discriminatedUnion('key', [
  AchPaymentStatusFilter,
  AchTransactionTypeFilter,
  AchBatchDateFilter,
]);
export type AchBatchTransactionFilter = z.infer<typeof AchBatchTransactionFilter>;
